import './CreativeMetadataInputCard.scss';
import { Card, Form } from 'react-bootstrap';
import { Img } from '@Components/Img';
import { Dropdown } from '@Components/Dropdown';
import { getCreativeThumbnail } from '@Components/MetricsTable/metrics-table-utils';
import { Placement, Size } from '@Components/designConstants';

interface CreativeProp {
  isci: string;
  name: string;
  length: number;
}

interface CreativeMetadataInputCardProps {
  company: string;
  creative: CreativeProp;
  clickthroughUrl: string;
  onClickthroughUrlInput: (isci: string, value: string) => void;
  audioCompanionOptionsList: { label: string; value: string }[];
  audioCompanion: string;
  onAudioCompanionSelect: (isci: string, value: string) => void;
}

export const CreativeMetadataInputCard = ({
  company,
  creative,
  clickthroughUrl,
  onClickthroughUrlInput,
  audioCompanionOptionsList,
  audioCompanion,
  onAudioCompanionSelect
}: CreativeMetadataInputCardProps) => (
  <Card className='creative-metadata-input-card'>
    <div className='creative-content'>
      <div className='creative-img-box'>
        <Img
          src={getCreativeThumbnail(company, creative.isci)}
          className='creative-img'
          unloader={<div className='no-img'>Thumbnail not found</div>}
        />
      </div>
      <div className='isci'>{creative.isci}</div>
      <div className='creative-name'>{`${creative.name} (${creative.length}s)`}</div>
    </div>
    <div className='input-container'>
      <div className='input-label'>Click-Through URL:</div>
      <Form.Control
        value={clickthroughUrl}
        onChange={e => onClickthroughUrlInput(creative.isci, e.target.value)}
      />
      {Boolean(audioCompanionOptionsList.length) && (
        <div className='companion-container'>
          <div className='input-label'>Audio Companion Banner:</div>
          <Dropdown
            overlayPlacement={Placement.RIGHT}
            size={Size.LG}
            options={audioCompanionOptionsList}
            value={audioCompanion}
            onChange={val => onAudioCompanionSelect(creative.isci, val)}
            dropdownMenuClassName='companion-dropdown-menu'
          />
        </div>
      )}
    </div>
  </Card>
);
